import React, { Component } from 'react';
import queryString from 'querystring';
import { API_URL, EVENT_ID, getUserID } from '../constants';
import { CssBaseline, withStyles } from '@material-ui/core';
import Topbar from '../components/Topbar';
import './BoothMain.css';
import Booth from './Booth';
import cloneDeep from 'lodash/cloneDeep';
import axios from 'axios';
// import CloseIcon from '@material-ui/icons/Close';
// import IconButton from '@material-ui/core/IconButton';
// import Button from '@material-ui/core/Button';
// import EVT from '../images/evt.png';
// import EVENT from '../images/event_01.png';
// import EVENT2 from '../images/event_02.png';
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';

const styles = (theme) => ({
  snackbar: {
    '& .MuiSnackbarContent-root': {
      backgroundColor: 'white',
      color: 'black',
    },
  },
  popupOuter: {
    position: 'relative',
  },
  popupImg: {
    width: '100%',
    height: '100%',
  },
  txtEvent: {
    fontSize: '18px',
    position: 'absolute',
    top: '80%',
    backgroundColor: '#fff',
    borderRadius: '10px',
    wordBreak: 'keep-all',
    [theme.breakpoints.down('md')]: {
      fontSize: '15px',
    },
    [theme.breakpoints.down('sm')]: {},
  },
});
class Exhibition extends Component {
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  };

  constructor(props) {
    super(props);
    // eslint-disable-next-line
    const { cookies } = props;
    let param = queryString.parse(this.props.location.search.replace('?', ''));

    this.state = {
      result: [],
      myData: null,
      param: param,
      snack1Open: false,
      snack2Open: false,
      snack3Open: false,
      eventLimit: 600,
      goDetail: false,
      alramDialog: false,
      openExPopup: false,
    };
    this.goDetail = this.goDetail.bind(this);
  }

  closeAlramDialog = () => {
    this.setState({ alramDialog: false });
  };

  getBoothList(param) {
    // eslint-disable-next-line
    const { cookies } = this.props;

    axios.get(`${API_URL}/booth/list?evt=${EVENT_ID}&userid=${getUserID()}`, { headers: { Pragma: 'no-cache' } }).then((response) => {
      // console.log(response);

      let _result = response.data;
      let visit = _result.stamp.Item ? _result.stamp.Item.booth : [];
      let datas = cloneDeep(_result.data.Items);

      if (visit.length >= datas.length) {
        // if (cookies.get(getUserID(true) + '_boothFinish') !== 'true') {
        //   document.getElementById('popup').style.display = 'flex';
        //   cookies.set([getUserID(true) + '_boothFinish'], true);
        // } else {
        //   this.setState({ snack3Open: true, snack3Show: true });
        // }
      } else {
        // if (first.ScannedCount < this.state.eventLimit) {
        // this.setState({ snack1Open: true });
        // } else {
        // this.setState({ snack2Open: true });
        // }
      }

      let bNotFound = true;

      for (let i = 0; i < datas.length; i++) {
        for (let j = 0; j < visit.length; j++) {
          if (datas[i].id === visit[j].boothId) {
            datas[i].visit = true;
          }
        }
      }

      for (let i = 0; i < datas.length; i++) {
        if (datas[i].visit !== true) {
          bNotFound = false;
        }
      }

      if (param && bNotFound) {
        this.setState({ alramDialog: true });
      }

      this.setState({ result: datas });
    });
  }

  emitBoothVisit = (param) => {
    console.log('emitBoothVisit');
    this.getBoothList(true);
  };

  componentDidMount() {
    if (!sessionStorage.getItem('_in_user_')) {
      this.props.history.push('signin');
      return;
    }
    this.getBoothList(false);
  }

  closePopup() {
    document.getElementById('popup').style.display = 'none';
    document.getElementById('event-01').style.display = 'none';
  }

  handleClose(id) {
    document.getElementById('popup').style.display = 'none';
    if (id === 'snack1') {
      this.setState({ snack1Open: false });
    } else if (id === 'snack2') {
      this.setState({ snack2Open: false });
    } else if (id === 'snack3') {
      this.setState({ snack3Open: false });
    }
  }

  closeWindow() {
    // window.open('', '_self').close();
    window.opener = 'Self';
    window.open('', '_parent', '');
    window.close(); // 일반적인 현재 창 닫기
    window.open('about:blank', '_self').self.close(); // IE에서 묻지 않고 창 닫기
  }

  goDetail() {
    this.setState({ goDetail: !this.state.goDetail });
  }
  closeExDialog = (event) => {
    this.setState({ openExPopup: false });
  };
  render() {
    // const { classes } = this.props;
    const currentPath = this.props.location.pathname;
    return (
      <React.Fragment>
        <CssBaseline />
        <Topbar currentPath={currentPath} />
        <div className={'main_bg'}>
          <Booth datas={this.state.result} emitBoothVisit={this.emitBoothVisit} />
        </div>
      </React.Fragment>
    );
  }
}

export default withCookies(withStyles(styles, { withTheme: true })(Exhibition));
